import { getRecordTerm } from '../../services/TermsService'

export const getPlanLinks = terms => {
  const name = getRecordTerm(terms, 'smartPlanBuilderTerm', 'Smart Plans')
  return [
    { href: '/plans', icon: ['fal', 'clipboard-list-check'], title: `My ${name}` },
    { href: '/behaviour/drafts', icon: ['fal', 'pencil'], title: `Incomplete ${name}` }
  ]
}
